import { Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { buildLink } from '../../../../../services/companyFilings/companyFilings.service';
import { CompanyFilingsDto } from '../../../../../services/dtos/companyFilings/companyFilings.dto';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import styles from './CompanyFilingsFileNameRenderer.module.scss';

const cx = classNames.bind(styles);

const CompanyFilingsFileNameRenderer = ({
  data,
  row: { isDisabled, isHovered },
}: GroupedTableRowRendererProps<CompanyFilingsDto>): React.ReactElement => {
  return (
    <div className={cx('body', { 'gray-out': isHovered && isDisabled })}>
      <span>
        <Icon name={ICONS.Doc} />
      </span>
      <span>
        <a href={buildLink(data)} target="_blank" rel="noreferrer">
          {data.uploadedFile.originalFilename}
        </a>
      </span>
    </div>
  );
};

export default CompanyFilingsFileNameRenderer;
